import type {DetectedContactDetails} from '../../../../store/features/calls/callsService';

export interface ContactPrefill {
    firstName?: string;
    lastName?: string;
    email?: string;
    company?: string;
}

export type ContactField = keyof ContactPrefill;

export const CONTACT_FIELDS: readonly ContactField[] = ['firstName', 'lastName', 'company', 'email'];

const clean = (value: string | null | undefined): string => (value ?? '').trim();

export const suggestionPrefill = (details: DetectedContactDetails | null | undefined): ContactPrefill => {
    const prefill: ContactPrefill = {};
    for (const field of CONTACT_FIELDS) {
        const value = clean(details?.[field]);
        if (value) prefill[field] = value;
    }
    return prefill;
};

export const missingFields = (
    existing: Partial<Record<ContactField, string | null | undefined>> | null | undefined,
    details: DetectedContactDetails | null | undefined,
): ContactPrefill => {
    const suggested = suggestionPrefill(details);
    const missing: ContactPrefill = {};
    for (const field of CONTACT_FIELDS) {
        if (suggested[field] && !clean(existing?.[field])) missing[field] = suggested[field];
    }
    return missing;
};

export const hasAnyField = (prefill: ContactPrefill): boolean => CONTACT_FIELDS.some((field) => Boolean(prefill[field]));

export const fillBlanks = <T extends Partial<Record<ContactField, string>>>(values: T, prefill: ContactPrefill | undefined): T => {
    if (!prefill) return values;
    const next = {...values};
    for (const field of CONTACT_FIELDS) {
        if (prefill[field] && !clean(next[field])) (next as Record<ContactField, string>)[field] = prefill[field] as string;
    }
    return next;
};
